import { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const toggleButtonOverride: ToggleButtonDesignTokens = {
  root: {
    padding: `${getRem(6)}`,
    gap: getRem(8),
    borderRadius: getRem(10),
    focusRing: {
      color: getColor('SeaBlue'),
    },
  },
  icon: {
    disabledColor: '{form.field.disabled.color}',
  },
  content: {
    borderRadius: getRem(6),
    checkedShadow: 'none',
    padding: `${getRem(3)} ${getRem(10)}`,
  },
  colorScheme: {
    light: {
      root: {
        background: getColor('UiWhite'),
        checkedBackground: getColor('SeaBlue'),
        hoverBackground: getColor('UiWhite'),
        borderColor: getColor('SeaBlue'),
        color: getColor('SeaBlue'),
        hoverColor: getColor('SeaBlue'),
        checkedColor: getColor('UiWhite'),
        checkedBorderColor: getColor('SeaBlue'),
      },
      content: {
        checkedBackground: 'transparent',
      },
      icon: {
        color: getColor('SeaBlue'),
        hoverColor: getColor('SeaBlue'),
        checkedColor: getColor('UiWhite'),
      },
    },
  },
};
